import { plugin, debug, join } from 'light-component';
import { Switch } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { Block } from '../../block';
import { t } from '../../i18n';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { CustomCollapseProps } from './types';

export function WidgetCollapse(props: CustomCollapseProps): ReactElement {
  debug.widget('dashboard collapse', props);

  const isFocus = props?.focus === props.name;

  if (props.mode === 'thumbnail') {
    return (
      <ThumbnailCollapse />
    );
  }
  return (
    <div className={isFocus ? join(styles.collapse, styles.focus) : styles.collapse}>
      <Header {...props} />
      <Body {...props} />
    </div>
  );
}

function Header(props: CustomCollapseProps): ReactElement {
  const expand = props.value == null || props.value?.expand === true;
  const onClickToggle = (checked: boolean, event: React.MouseEvent<HTMLButtonElement>): void => {
    props.onChange?.({ toggle: checked });
    event.stopPropagation();
    if (checked) {
      props.onChange?.({ expand: false, toggle: checked });
    }
  };

  const onHeaderClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    event.preventDefault();
    props.onChange?.(expand ? { expand: false } : { expand: true });
  };

  return (
    <div className={join(
      styles.header,
      { [styles.gap]: props.showChildren !== false && !expand }
    )} onClick={onHeaderClick}>
      {props.toggle != null && (<Switch checked={props.toggle} size='small' onClick={onClickToggle} />)}
      <span className={styles.headerText}>{t(props.title)}</span>
      <Block if={props.showChildren !== false && expand}>
        <Icons name='LeftOutlined' className={styles.headerClip} />
      </Block>
      <Block if={props.showChildren !== false && !expand}>
        <Icons name='DownOutlined' className={styles.headerClip} />
      </Block>
    </div>
  );
}

function Body(props: CustomCollapseProps): ReactElement | null {
  if (props.value == null || props.value?.expand === true) {
    return null;
  }
  return (
    <div>
      {props.children}
    </div>
  );
}

function ThumbnailCollapse(): ReactElement {
  return (
    <div className={styles.control}>
      <Icons name='AppstoreAddOutlined' className={styles.icon} />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'collapse', component: WidgetCollapse });
